import { render, staticRenderFns } from "./unauthorized.vue?vue&type=template&id=0fd4abac&scoped=true&"
var script = {}
import style0 from "./unauthorized.vue?vue&type=style&index=0&id=0fd4abac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd4abac",
  null
  
)

export default component.exports